// eslint-disable-next-line import/prefer-default-export
export const ServiceTypes = {
    engagementAfterRating: 'engagement_after_rating',
    immediateEngagement: 'immediate_engagement',
};

export const PositionStatuses = {
    DRAFT: 'Draft',
    READY: 'Ready',
    ACTIVE: 'Active',
    DONE: 'Done',
    CLOSED_BY_ATS: 'Closed By ATS',
    CANCELLED: 'Cancelled',
    FINISHED: 'Finished',
};

export const synteticPositionStatuses = {
    new: 'New',
    sent: 'Sent',
    requestFeedback: 'requstFeedback',
    feedbackAccepted: 'feedbackAccepted',
};

export const openPositionStatuses = [
    synteticPositionStatuses.new,
    synteticPositionStatuses.sent,
    synteticPositionStatuses.requestFeedback,
    synteticPositionStatuses.feedbackAccepted,

    PositionStatuses.ACTIVE,
    PositionStatuses.READY,
    PositionStatuses.DRAFT,
];

export const positionEvents = {
    scrapeRequested: 'scrape_requested',
    scrapeCompleted: 'scrape_completed',
    scrapeBypassed: 'scrape_bypassed',
    insightGenerated: 'insight_generated',
    insightUpdated: 'insight_updated',
    insightSent: 'insight_sent',
    feedbackRequested: 'feedback_requested',
    feedbackRatingStarted: 'feedback_rating_started',
    feedbackRatingUpdated: 'feedback_rating_updated',
    feedbackRatingCompleted: 'feedback_rating_completed',
    createJob: 'create_job',
    editJob: 'edit_job',
    chooseSamples: 'choose_samples',
    tips: 'tips',
    preliminaryFeedback: 'preliminary_feedback',
    wizardComplete: 'complete',
    calibrationRequest: 'calibration_request',
    atsStatusPush: 'ats_status_push',
    fastRating: 'fast_rating',
};

export const positionEventFlowTypes = {
    feedback: 'feedback',
    positionWizard: 'positionWizard',
    insight: 'insight',
};

export const PositionHistoryEditStages = {
    edit: 'edit',
    conditionalApproval: 'conditionalApproval',
    calibration: 'calibration',
    review: 'review',
    manage: 'manage',
};

export const PositionAtsPushStatus = {
    manual_qualify_flow: 'manual_qualify_flow',
    ai_sourcing_on: 'ai_sourcing_on',
    ai_sourcing_off: 'ai_sourcing_off',
    calibration_completed: 'calibration_completed',
    calibration_ready: 'calibration_ready',
    waiting_for_calibration: 'waiting_for_calibration',
    waiting_for_selecting_the_engagement: 'waiting_for_selecting_the_engagement',
    unknown: 'unknown',
};

export const getPositionStatusLabel = (status, t) => {
    switch (status) {
        case PositionStatuses.CANCELLED:
            return t('POSITION_STATUS_CANCELLED_LABEL', 'Closed');
        case PositionStatuses.CLOSED_BY_ATS:
            return t('POSITION_STATUS_CLOSED_BY_ATS_LABEL', 'Closed by ATS');
        default: return status;
    }
};

export const RecalibrationFlowTypes = {
    new: 'new',
    edit: 'edit',
    none: 'none',
};

export const MAX_LOCATIONS_COUNT_PER_POSITION = 15;
